import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';
import { AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, User, Shield } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      login(response.data.access_token, response.data.user);
      toast.success('Login admin realizado com sucesso!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Logo/Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 border border-primary/30 rounded-full mb-4">
            <Shield className="w-10 h-10 text-primary" />
          </div>
          <h1 className="font-unbounded font-bold text-3xl tracking-tight uppercase">
            <span className="text-white">Admin</span>{' '}
            <span className="text-primary">Dashboard</span>
          </h1>
          <p className="text-muted-foreground mt-2">Challenge Run 6.0</p>
        </div>

        {/* Login Form */}
        <div className="glass-card p-8">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="username" className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-2 block">
                Usuário
              </Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <Input
                  id="username"
                  data-testid="admin-username-input"
                  type="text"
                  required
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  className="pl-12 bg-secondary/50 border-white/10 focus:border-primary focus:ring-1 focus:ring-primary/50 font-mono text-sm h-12"
                  placeholder="admin"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-2 block">
                Senha
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <Input
                  id="password"
                  data-testid="admin-password-input"
                  type="password"
                  required
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  className="pl-12 bg-secondary/50 border-white/10 focus:border-primary focus:ring-1 focus:ring-primary/50 font-mono text-sm h-12"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <Button
              data-testid="admin-login-button"
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-black font-unbounded font-bold uppercase tracking-wider hover:bg-primary/90 h-12 skew-btn"
            >
              <span>{loading ? 'Entrando...' : 'Entrar'}</span>
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-muted-foreground hover:text-primary transition-colors text-sm"
            >
              Voltar para o site
            </button>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-muted-foreground">
          <p>Credenciais padrão: admin / admin123</p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
